import setting from "./setting"
import objectiveAutoEval from "./objectiveAutoEval"
import user from "./user"
import hierarchical from "./hierarchical"
import profil from "./profil"
import report from "./report"
import history from "./history"
import guide from "./guide"
import dashBoard from "./dashBoard"

export default [
    //...dashBoard ,
 ...profil,...objectiveAutoEval,...hierarchical,...report, ...user, ...history, ...setting, ...guide
]
